import React, { useEffect, useState } from "react";
import { CommonHeader, Loader } from "../../../components/commons";
import AddressCard from "../../../components/ClientSettings/AddressManager/AddressCard";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  getAllBusinessAddressAction,
  resetBusinessAddressList,
  resetClientSettingsError,
  resetClientSettingsSuccess,
} from "../../../redux/clientSettings";
import { resetSession } from "../../../redux/auth";
import { BusinessAddressListType } from "../../../redux/clientSettings/clientSettingTypes";
import { SearchIcon } from "../../../components/Icon";
import { GetAllBussinessAddressesListPayloadType } from "../../../commonTypes/clientSettingsTypes";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

type AppProps = {
  history?: any;
  token: string | null;
  fetching: boolean;
  error: string | null;
  statusCode: number | null;
  businessAddressList: [] | BusinessAddressListType[];
  dispatchResetClientSettingsError: () => void;
  dispatchResetClientSettingsSuccessAction: () => void;
  dispatchResetBusinessAddressList: () => void;
  dispatchGetAllBusinessAddressList: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  dispatchResetSession: () => void;
};

const AddressManager = ({
  history,
  token,
  fetching,
  error,
  statusCode,
  businessAddressList,
  dispatchGetAllBusinessAddressList,
  dispatchResetClientSettingsError,
  dispatchResetClientSettingsSuccessAction,
  dispatchResetSession,
  dispatchResetBusinessAddressList,
}: AppProps) => {
  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code;
  const [searchData, setSearchData] = useState("");

    	//========== User Management  ==========//
	const [isAddressAddPresent, setIsAddressAddPresent] = useMenuCheck();
  const [isAddressEditPresent, setIsAddressEditPresent] = useMenuCheck();
	//====================//

  useEffect(() => {
    dispatchResetBusinessAddressList()
    if (token && client_code) {
      let finalData = { token, client_code };
      dispatchGetAllBusinessAddressList(finalData);
      setIsAddressAddPresent("Add Business Address","menu")
      setIsAddressEditPresent("Edit Business Address","menu")
    }
    //eslint-disable-next-line
  }, []);

  const fetchNewData = (search?: string) => {
    if (token && client_code) {
      let finalData = {
        token,
        client_code,
        search_term: search,
      };
      dispatchGetAllBusinessAddressList(finalData);
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData) {
        fetchNewData(searchData);
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
    //eslint-disable-next-line
  }, [searchData]);

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);

    if (value?.length === 0) {
      dispatchGetAllBusinessAddressList({ token, client_code });
    }
  };

  const renderBusinessAddressList = () => {
    const finalBusinessAddressList = businessAddressList?.length>0&&businessAddressList?.map(
      (businessAddress: BusinessAddressListType) => {
        if (!businessAddress?.is_default_address) {
          return (
            <AddressCard
              key={businessAddress?.ledger_id}
              data={businessAddress}
              history={history}
              company_name={company_name}
              client_code={client_code}
              isAddressEditPresent={isAddressEditPresent}
            />
          );
        }
      }
    );

    return finalBusinessAddressList;
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6 mb-3">
          <CommonHeader
            title="Business Addresses"
            company_name={company_name}
            client_code={client_code}
          />
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-4">
              <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                <SearchIcon />
              </span>
              <input
                className="form-control"
                type="text"
                placeholder="Search Business Address"
                onChange={(e) => handleSearch(e)}
                style={{ paddingLeft: "35px" }}
              />
            </div>
          </div>
          <div className="d-flex flex-wrap align-items-center">
           {!!businessAddressList[0]?.is_default_address && <AddressCard
              data={businessAddressList[0]}
              history={history}
              company_name={company_name}
              client_code={client_code}
              isAddressEditPresent={isAddressEditPresent}
            />}
          {isAddressAddPresent && <AddressCard
              client_code={client_code}
              company_name={company_name}
              isAddNewAddress
              isAddressEditPresent={isAddressEditPresent}
            />}
          </div>
          
        
            <div className="row col-md-9" style={{marginTop:"16px",width:"300px"}}>
            <span style={{ fontSize:'18px',color:'#262a44'}}>Other Addresses</span>       
            <span style={{color:"#858d94",fontSize:'14px'}}>(Total {businessAddressList[0]?.is_default_address?businessAddressList?.length-1:businessAddressList?.length} Addresses found)</span>
          </div>
          <div className="d-flex flex-wrap align-items-center">
            {renderBusinessAddressList()}
          </div>
        
         
        </div>
      </div>
      {fetching && <Loader />}
    </>
  );
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.clientSettings.fetching,
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode,
  businessAddressList: state.clientSettings.businessAddressList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchResetClientSettingsSuccessAction: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchGetAllBusinessAddressList: (
    data: GetAllBussinessAddressesListPayloadType
  ) => dispatch(getAllBusinessAddressAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetBusinessAddressList: () => dispatch(resetBusinessAddressList()),
});

export default connect(mapStateTopProps, mapDispatchToProps)(AddressManager);
